import { render, staticRenderFns } from "./ficha-inmueble.vue?vue&type=template&id=55558a69&"
import script from "./ficha-inmueble.vue?vue&type=script&lang=js&"
export * from "./ficha-inmueble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports